import {Component} from "preact";
import styles from './styles.scss';
import {isIE} from "../../../utilities/detectIE";

export default class ToolbarButton extends Component {
    static defaultProps = {
        type: '',
        style: {},
        disabled: false,
        title: ''
    };

    render(props, state, context) {
        const additionalClasses = [];
        if (props.type) props.type.split(' ').forEach(type => additionalClasses.push(styles[type]));
        if (props.class) additionalClasses.push(props.class);
        if (isIE()) additionalClasses.push(styles.ie)
        if (props.disabled) additionalClasses.push(styles.disabled);

        return (
            <button type='button'
                    class={[styles.customButton].concat(additionalClasses).join(' ')}
                    style={props.style}
                    onClick={!props.disabled && this.props.onClick}
                    tabIndex={props.disabled ? -1 : 0}
                    title={props.title}
                    disabled={props.disabled}
            >
                <span>
                    {props.children}
                </span>
            </button>
        );
    }
}



// WEBPACK FOOTER //
// ./components/common/toolbar-button/index.js